export default __webpack_public_path__ + "static/media/login-Insta.1ee4714e.svg";